import React, {Component} from "react";
import Home from "../../../images/home.jpg";
import projectData from "./projectData";
import ProjectCard from "./projectCard";
import { Link } from "react-router-dom";
 

class UpComingProject extends Component{

    constructor(props){
        super(props);
        this.state = {
            sliceLimit : 6,
        }
    }

    render(){
        return(
            <div className="breadcrumb-area">
                <div className="flex-title">
                    <h1>Upcoming projects</h1>
                    <h4 className="prim-txt">
                        <Link to="/upcoming-projects">
                            View more projects
                        </Link>
                    </h4>
                </div>
                <div className="project-widget">
                    {projectData.slice(0, this.state.sliceLimit).map((item) => <ProjectCard key={item.id} name={item.name} desc={item.desc} />)}
                </div>
            </div>
        );
    }
}

export default UpComingProject;